import Testimonials7 from './Testimonials7'
export default Testimonials7
